const reduxFirebaseConfig = {
    userProfile: 'users',
    useFirestoreForProfile: true
}

export default reduxFirebaseConfig